import rest from "@/rest-client";
import createCrudVuexModule from "@/store/crud";

export const organizationPhysicalStorage = createCrudVuexModule({
  namespaced: true,
  path: "/physical-storage",
  actions: {
    async addFromLibrary({ commit }, payload) {
      commit("isUpdating", true);
      try {
        const response = await rest.post("/physical-storage/add-from-library", payload);
        return response;
      } finally {
        commit("isUpdating", false);
      }
    },
  },
});
